import { TextLink } from './textLink';

interface ReadMoreLinkProps {
  text?: string;
  href: string;
  className?: string;
}

export const ReadMoreLink = ({ text, href, className }: ReadMoreLinkProps) => {
  const textWithArrow = `${text || 'Learn more'} →`;
  return (
    <TextLink href={href} target='_blank' className={className}>
      {textWithArrow}
    </TextLink>
  );
};
